import { createRouter, createWebHistory } from 'vue-router';
import routes from '~pages';

let routerInstance = null;

export function getRouter() {
  return routerInstance;
}

export default function initRouter() {
  routerInstance = createRouter({
    history: createWebHistory(),
    routes: [
      {
        path: '/',
        redirect: () => {
          return localStorage.getItem('isLoggedIn') ? '/functions' : '/login';
        },
      },
      ...routes, // 其他自動生成的路由
    ],
  });

  routerInstance.beforeEach((to) => {
    const isLoggedIn = !!localStorage.getItem('isLoggedIn');

    if (isLoggedIn && to.path === '/login') {
      return '/functions';
    }

    if (!isLoggedIn && to.path !== '/login') {
      return '/login';
    }
  });

  return { router: routerInstance };
}
